import React from 'react';
import { cn } from '@/lib/utils';
import { Check } from 'lucide-react';

export const HorizontalStepTracker = ({ steps, currentStep }) => {
  return (
    <div className="w-full py-8">
      <div className="relative flex items-center justify-between">
        {steps.map((step, index) => {
          const stepNumber = index + 1;
          const isCompleted = stepNumber < currentStep;
          const isCurrent = stepNumber === currentStep;
          const isPending = stepNumber > currentStep;

          return (
            <React.Fragment key={step.id || index}>
              {/* Connector Line */}
              {index > 0 && (
                <div className="flex-1 h-0.5 -mx-4">
                  <div
                    className={cn(
                      'h-full transition-all',
                      isCompleted || (isCurrent && index > 0)
                        ? 'bg-primary'
                        : 'bg-border'
                    )}
                  />
                </div>
              )}

              {/* Step Circle */}
              <div className="relative flex flex-col items-center">
                <div
                  className={cn(
                    'flex h-10 w-10 items-center justify-center rounded-full border-2 font-semibold text-sm transition-all z-10',
                    isCompleted &&
                      'bg-primary border-primary text-primary-foreground',
                    isCurrent &&
                      'bg-white border-primary text-primary ring-4 ring-primary/20',
                    isPending && 'bg-white border-border text-muted-foreground'
                  )}
                >
                  {isCompleted ? (
                    <Check className="h-5 w-5" />
                  ) : (
                    stepNumber
                  )}
                </div>
                <div className="mt-2 text-center max-w-[120px]">
                  <p
                    className={cn(
                      'text-xs font-medium',
                      isCurrent ? 'text-primary' : 'text-muted-foreground'
                    )}
                  >
                    {step.label || step.name}
                  </p>
                  {step.description && (
                    <p className="text-xs text-muted-foreground mt-1">
                      {step.description}
                    </p>
                  )}
                </div>
              </div>
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};
